import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { Box, ClickAwayListener, PrimaryButton } from '../index';
import { Tooltip } from '../Tooltip/Tooltip';
import { makeStyles } from '../../themes';
function getBackgroundColor({ color }, theme) {
    var _a;
    if (color === 'light') {
        return theme.palette.text.inverse;
    }
    if (theme.name === 'liquidity') {
        return (_a = theme.palette.tooltip) === null || _a === void 0 ? void 0 : _a.dark;
    }
    return theme.palette.background.hint;
}
function getTextColor({ color }, theme) {
    if (color === 'light') {
        return theme.palette.text.primary;
    }
    return theme.palette.text.inverse;
}
const useStyles = makeStyles((theme) => ({
    tooltip: ({ color }) => ({
        color: getTextColor({ color }, theme),
        backgroundColor: getBackgroundColor({ color }, theme),
        borderRadius: 5,
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.3)',
        padding: 0,
        maxWidth: 'none',
        '&.MuiTooltip-tooltipPlacementBottom $arrow': {
            marginTop: '-1.71em',
        },
        '&.MuiTooltip-tooltipPlacementTop $arrow': {
            marginBottom: '-1.71em',
        },
    }),
    popper: {
        pointerEvents: 'auto',
    },
    arrow: ({ color }) => ({
        color: getBackgroundColor({ color }, theme),
        height: '1.71em',
        width: '2.5em',
    }),
}));
const ArrowPopoverContainer = (props) => (_jsx(Tooltip, Object.assign({}, props, { classes: useStyles({ color: props.color }) }, { children: props.children }), void 0));
export const ArrowPopover = ({ children, title, ariaLabel, onTooltipClose, placement, color = 'light', withApplyButton, }) => {
    const [open, setOpen] = useState(false);
    const popoverTriggerRef = useRef(null);
    const handleTooltipClose = () => {
        setOpen(false);
    };
    const toggleTooltipOnKeyUp = ({ key }) => {
        if (key === 'Enter') {
            setOpen((prev) => !prev);
        }
    };
    const closeTooltipOnEscapeClick = ({ key }) => {
        if (key === 'Escape') {
            handleTooltipClose();
        }
    };
    const onClickAway = ({ target }) => {
        var _a;
        if (!((_a = popoverTriggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
            handleTooltipClose();
        }
    };
    const handleApply = () => {
        if (withApplyButton === null || withApplyButton === void 0 ? void 0 : withApplyButton.onApply) {
            withApplyButton.onApply();
        }
        handleTooltipClose();
    };
    useEffect(() => {
        if (!open && onTooltipClose) {
            onTooltipClose();
        }
    }, [open]);
    useEffect(() => {
        function handleKeyUpOutside({ key, target }) {
            var _a;
            if (key === 'Enter' && !((_a = popoverTriggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                handleTooltipClose();
            }
        }
        document.addEventListener('keyup', handleKeyUpOutside);
        return () => {
            document.removeEventListener('keyup', handleKeyUpOutside);
        };
    }, [popoverTriggerRef]);
    return (_jsx(ArrowPopoverContainer, Object.assign({ title: _jsx(ClickAwayListener, Object.assign({ onClickAway: onClickAway, mouseEvent: "onMouseUp" }, { children: _jsx("div", Object.assign({ onKeyUp: closeTooltipOnEscapeClick }, { children: _jsxs(Box, Object.assign({ p: 2 }, { children: [title,
                        withApplyButton && (_jsx(Box, Object.assign({ justifyContent: "right", display: "flex", pt: 2 }, { children: _jsx(PrimaryButton, Object.assign({ onClick: () => handleApply(), size: "medium" }, (withApplyButton.disabled && { disabled: withApplyButton.disabled }), (withApplyButton.testId && { 'data-testid': withApplyButton.testId }), { children: withApplyButton.applyText }), void 0) }), void 0))] }), void 0) }), void 0) }), void 0), PopperProps: {
            disablePortal: true,
        }, open: open, arrow: true, placement: placement, color: color }, { children: _jsx("div", Object.assign({ ref: popoverTriggerRef }, { children: _jsx(Box, Object.assign({ display: "block", onClick: () => setOpen((prev) => !prev), tabIndex: 0, onKeyUp: toggleTooltipOnKeyUp, role: "button", "aria-label": ariaLabel }, { children: children }), void 0) }), void 0) }), void 0));
};
//# sourceMappingURL=ArrowPopover.js.map